(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6057],{

/***/ 88808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35005);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61909);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* harmony import */ var _services_my_account__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42169);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13135);










var MyAccountModal = function(props) {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var defaultProv = "Manitoba";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), storeList = ref[0], setStoreList = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_SITE_LINK */ .qP), siteLink = ref1[0], setSiteLink = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), provinceList = ref2[0], setProvinceList = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), facilityList = ref3[0], setProvinceFacility = ref3[1];
    var onClose = props.onClose, open = props.open;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("Ontario - GTA"), province = ref4[0], setProvince = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultProv), store = ref5[0], setStore = ref5[1];
    var filterFacility = function(data, facilitySlug) {
        var ref, ref1, ref2;
        var filterFac = (ref = data.find(function(element) {
            var ref;
            return (element === null || element === void 0 ? void 0 : (ref = element.attributes) === null || ref === void 0 ? void 0 : ref.Name) === facilitySlug;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Facilities) === null || ref2 === void 0 ? void 0 : ref2.data;
        if (!filterFac) return filterFac;
        if (facilitySlug === "Ontario - GTA") {
            var L019 = filterFac.find(function(el) {
                return el.attributes.Title === "East York";
            });
            if (!L019) {
                L019 = {
                    attributes: {
                        Facility_ID: "L019",
                        Sitelink_URL_ID: "OWoeNxkDG6/HY0SEnoxFgw",
                        Title: "East York",
                        Address: {
                            Street_1: "40 Beth Nealson Dr."
                        }
                    }
                };
                filterFac.splice(13, 0, L019);
            }
        }
        return filterFac;
    };
    var getProvinceData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var ref, brand, provinceListD, provinceData, prov, provS;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        brand = _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .BRAND_NAME_EN */ .Vp;
                        if (locale === "fr") brand = _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .BRAND_NAME_FR */ .Fj;
                        return [
                            4,
                            (0,_services_my_account__WEBPACK_IMPORTED_MODULE_3__/* .getAllProvincesData */ .E)(locale, brand)
                        ];
                    case 1:
                        provinceListD = _state.sent();
                        return [
                            4,
                            provinceListD === null || provinceListD === void 0 ? void 0 : (ref = provinceListD.data) === null || ref === void 0 ? void 0 : ref.data
                        ];
                    case 2:
                        provinceData = _state.sent() || null;
                        setProvinceFacility(provinceData);
                        filterFacility(provinceData, defaultProv);
                        setStoreList(filterFacility(provinceData, defaultProv));
                        prov = [];
                        provinceData.forEach(function(element) {
                            var ref;
                            prov.push(element === null || element === void 0 ? void 0 : (ref = element.attributes) === null || ref === void 0 ? void 0 : ref.Name);
                        });
                        setProvinceList(prov);
                        provS = [];
                        provinceData.forEach(function(element) {
                            var ref;
                            provS.push(element === null || element === void 0 ? void 0 : (ref = element.attributes) === null || ref === void 0 ? void 0 : ref.Slug);
                        });
                        setStore(prov[0]);
                        return [
                            2
                        ];
                }
            });
        });
        return function getProvinceData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleStore = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
            var ref, ref1, currentprovince;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                setStoreList([]);
                if (e && e.target) setProvince(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                currentprovince = e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value;
                setStoreList(filterFacility(facilityList, currentprovince));
                return [
                    2
                ];
            });
        });
        return function handleStore(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getProvinceData();
        handleStore(undefined);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, ref1;
        if (storeList === null || storeList === void 0 ? void 0 : storeList.length) setSiteLink(((ref = storeList[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Sitelink_URL_ID) || _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_SITE_LINK */ .qP);
    }, [
        storeList
    ]);
    var handleCloseClick = function() {
        return onClose();
    };
    var getSiteLink = function(e, data) {
        if (e && e.target) {
            var ref, ref1;
            var item = data.filter(function(val) {
                var ref, ref1, ref2;
                return "".concat(val === null || val === void 0 ? void 0 : (ref = val.attributes) === null || ref === void 0 ? void 0 : ref.Title, " - ").concat(val === null || val === void 0 ? void 0 : (ref1 = val.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Address) === null || ref2 === void 0 ? void 0 : ref2.Street_1) === e.target.value;
            });
            setSiteLink(((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Sitelink_URL_ID) || _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_SITE_LINK */ .qP);
        }
    };
    var handleSubmit = function() {
        window.open("".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .SITE_LINK */ .Ms, "sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=").concat(siteLink, "==&1=1"), "_blank");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        show: open,
        animation: false,
        id: "myAccountModal",
        onHide: handleCloseClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "modal-header",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        className: "modal-title",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "my-account-heading"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "border-0 bg-transparent text-white",
                        onClick: handleCloseClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            fill: "currentColor",
                            className: "bi bi-x-circle-fill",
                            viewBox: "0 0 16 16",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Body */ .Z.Body, {
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "modal-body",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        id: "my-account-subheading"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "fieldSet provinceField",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: "form-label",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                id: "my-account-province"
                                            }),
                                            ":"
                                        ]
                                    }, "provinceSelect"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                        className: "form-select provinceSelect",
                                        onChange: handleStore,
                                        defaultValue: province,
                                        children: provinceList.length ? provinceList.map(function(item) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                defaultValue: item,
                                                children: item
                                            }, item);
                                        }) : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "fieldSet facilityField",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: "form-label",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                id: "my-account-store"
                                            }),
                                            ":"
                                        ]
                                    }, "storeSelect"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                        className: "form-select storeSelect",
                                        "aria-label": " Select Store",
                                        onChange: function(e) {
                                            return getSiteLink(e, storeList);
                                        },
                                        defaultValue: store,
                                        children: (storeList === null || storeList === void 0 ? void 0 : storeList.length) ? storeList.map(function(item) {
                                            var ref, ref1, ref2, ref3;
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("option", {
                                                defaultValue: item,
                                                children: [
                                                    item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.Title,
                                                    " -",
                                                    " ",
                                                    item === null || item === void 0 ? void 0 : (ref1 = item.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Address) === null || ref2 === void 0 ? void 0 : ref2.Street_1
                                                ]
                                            }, item === null || item === void 0 ? void 0 : (ref3 = item.attributes) === null || ref3 === void 0 ? void 0 : ref3.Title);
                                        }) : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                className: "btn as-primary-btn verify w-100 mt-3",
                                onClick: handleSubmit,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    id: "my-account-button"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MyAccountModal);


/***/ }),

/***/ 16057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ laylout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
// EXTERNAL MODULE: ./src/keys/enkeys.ts
var enkeys = __webpack_require__(38410);
// EXTERNAL MODULE: ./src/keys/Frkeys.ts
var Frkeys = __webpack_require__(30971);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/footer/index.tsx


var AboutSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6945).then(__webpack_require__.bind(__webpack_require__, 96945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96945)
            ];
        }
    }
});
var CommunitySection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3270).then(__webpack_require__.bind(__webpack_require__, 53270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53270)
            ];
        }
    }
});
var CopyRightComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9238), __webpack_require__.e(3515)]).then(__webpack_require__.bind(__webpack_require__, 93515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93515)
            ];
        }
    }
});
var CorporateSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5340).then(__webpack_require__.bind(__webpack_require__, 95340));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95340)
            ];
        }
    }
});
var SocialLinks = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7240).then(__webpack_require__.bind(__webpack_require__, 47240));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47240)
            ];
        }
    }
});
var TrustSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1588).then(__webpack_require__.bind(__webpack_require__, 81588));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81588)
            ];
        }
    }
});
var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sv-footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutSection, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustSection, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunitySection, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateSection, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyRightComponent, {})
        ]
    });
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./public/images/logos/Access_Storage_Logo_RGB.svg
/* harmony default export */ var Access_Storage_Logo_RGB = ({"src":"/_next/static/media/Access_Storage_Logo_RGB.20987a6d.svg","height":250,"width":550});
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var home_setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/components/header/Header.module.scss
var Header_module = __webpack_require__(89449);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Crop.js
var Crop = __webpack_require__(11048);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/OpenInNew.js
var OpenInNew = __webpack_require__(54048);
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(19755);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/components/self-storage-moving/size-card.tsx + 2 modules
var size_card = __webpack_require__(64529);
;// CONCATENATED MODULE: ./public/images/icons/location-pin.svg
/* harmony default export */ var location_pin = ({"src":"/_next/static/media/location-pin.96c9087d.svg","height":13,"width":11});
// EXTERNAL MODULE: ./src/components/header/right-panel-menu/my-account-modal.tsx
var my_account_modal = __webpack_require__(88808);
// EXTERNAL MODULE: ./src/components/header/mobile-header/mobile.module.scss
var mobile_module = __webpack_require__(97734);
var mobile_module_default = /*#__PURE__*/__webpack_require__.n(mobile_module);
;// CONCATENATED MODULE: ./src/components/header/mobile-header/index.tsx















var MobileHeader = function(props) {
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = (0,react.useState)(false), sizeModal = ref1[0], setSizeModal = ref1[1];
    var ref2 = (0,next_router.useRouter)(), locales = ref2.locales, asPath = ref2.asPath, locale = ref2.locale;
    var router = (0,next_router.useRouter)();
    var storageDropdownRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        jquery_default()(function() {
            jquery_default()(".close-menu").on("click", function() {
                if (jquery_default()(".navbar-toggler").css("display") !== "none") {
                    jquery_default()(".navbar-toggler").trigger("click");
                }
            });
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "navbar-toggler",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#navbarSupportedContent",
                "aria-controls": "navbarSupportedContent",
                "aria-expanded": "false",
                "aria-label": "Toggle navigation",
                onClick: props.handleExpand,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "nav-icon3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "overlay-for-menu",
                style: props.showClass,
                onClick: props.handleExpand
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "navbar-collapse sidenav",
                id: "mobileNav",
                style: props.heightStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overlay-content",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "navbar-nav",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item pt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "nav-link close-menu d-flex",
                                    onClick: function() {
                                        return setSizeModal(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Crop/* default */.Z, {
                                                className: "sv-size-guid-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "header.size-guide"
                                        })
                                    ]
                                })
                            }),
                            sizeModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(size_card["default"], {
                                open: sizeModal,
                                onClose: function() {
                                    return setSizeModal(false);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "bg-dark sv-line"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "nav-item dropdown",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "nav-link dropdown-toggle storageDropdown",
                                        href: "#",
                                        id: "storageDropdown",
                                        role: "button",
                                        "data-bs-toggle": "dropdown",
                                        "aria-expanded": "false",
                                        ref: storageDropdownRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "header.self-storage"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "dropdown-menu dropdown-menu-end",
                                        "aria-labelledby": "storageDropdown",
                                        "data-bs-popper": "static",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/self-storage"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.store-locator"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/self-storage/residential"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.residential"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/self-storage/car-storage"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.vehicles"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/self-storage/student-storage"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.student-storage"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/self-storage/business"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.business"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/self-storage/moving"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.moving"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "bg-dark sv-line"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "nav-item dropdown",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "nav-link dropdown-toggle",
                                        href: "#",
                                        id: "portableStorageDropdown",
                                        role: "button",
                                        "data-bs-toggle": "dropdown",
                                        "aria-expanded": "false",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "header.portable-storage"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "dropdown-menu dropdown-menu-end",
                                        "aria-labelledby": "portableStorageDropdown",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/portable-storage/residential"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.residential"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/portable-storage/business-storage"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.business"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/portable-storage/moving"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.moving"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(router.locale, "/portable-storage/long-distance-moving"),
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "dropdown-item close-menu",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "header.long-dist-moving"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "bg-dark sv-line"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: constants/* PACKING_SUPPLIES_SHOP */.jJ,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "nav-link close-menu",
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "header.packing-supplies"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInNew/* default */.Z, {
                                                className: "sv-menu-shop-portal-icon"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "bg-dark sv-line"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item close-menu hidden-logo-xxs d-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/".concat(router.locale, "/self-storage"),
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "nav-link location",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: location_pin,
                                                alt: "location-pin",
                                                className: "location-pin-img",
                                                priority: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "header.find-storage"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "nav-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "nav-link close-menu",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: function() {
                                            return setShowModal(true);
                                        },
                                        className: (mobile_module_default()).pointer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "header.myaccount-makepayment"
                                        })
                                    })
                                })
                            }),
                            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(my_account_modal["default"], {
                                open: showModal,
                                onClose: function() {
                                    return setShowModal(false);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "bg-dark sv-line"
                            }),
                            (0,_to_consumable_array/* default */.Z)(locales).sort().map(function(llocale) {
                                return locale !== llocale ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item close-menu",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat(asPath),
                                        locale: llocale,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "nav-link",
                                            children: llocale === "en" ? "English" : "Fran\xe7ais"
                                        })
                                    })
                                }, llocale) : "";
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var mobile_header = (MobileHeader);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccountCircleOutlined.js
var AccountCircleOutlined = __webpack_require__(69436);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalPhoneOutlined.js
var LocalPhoneOutlined = __webpack_require__(8987);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 10 modules
var Button = __webpack_require__(13850);
// EXTERNAL MODULE: ./src/components/smart-button/style.module.scss
var style_module = __webpack_require__(45492);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/smart-button/smart-button.tsx






var SmartButton = function(param) {
    var onClick = param.onClick, text = param.text, iconProps = param.iconProps, _hasIcon = param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon, href = param.href, textClassName = param.textClassName, Icon = param.Icon, dot = param.dot;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        onClick: onClick,
        style: {
            backgroundColor: "#F2F2F2",
            color: "#1C1B1F",
            borderRadius: "8px",
            padding: "8px 16px",
            boxShadow: "none",
            minWidth: "20px",
            whiteSpace: "nowrap",
            fontFamily: "Hind",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "120%"
        },
        disableRipple: true,
        className: (style_module_default())["sv-smart-button"],
        sx: {
            "& .MuiButton-startIcon": {
                marginRight: "0px",
                marginLeft: "0px"
            }
        },
        variant: "contained",
        href: href,
        startIcon: hasIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, (0,_object_spread/* default */.Z)({}, iconProps)) : null,
        children: [
            text ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: textClassName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: text
                })
            }) : null,
            dot && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).filterDot
            })
        ]
    });
};
/* harmony default export */ var smart_button = (SmartButton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SearchOutlined.js
var SearchOutlined = __webpack_require__(58822);
// EXTERNAL MODULE: ./node_modules/react-places-autocomplete/dist/index.js
var dist = __webpack_require__(48837);
// EXTERNAL MODULE: ./src/context/MapCordinateContext.tsx
var MapCordinateContext = __webpack_require__(20546);
// EXTERNAL MODULE: ./src/utils/default.ts
var utils_default = __webpack_require__(84260);
// EXTERNAL MODULE: ./src/components/smart-textbox/style.module.scss
var smart_textbox_style_module = __webpack_require__(27034);
var smart_textbox_style_module_default = /*#__PURE__*/__webpack_require__.n(smart_textbox_style_module);
;// CONCATENATED MODULE: ./src/components/smart-textbox/smart-search-textbox.tsx















var SearchInput = function() {
    var ref = (0,next_router.useRouter)(), locale = ref.locale, push = ref.push;
    var ref1 = (0,react.useState)(""), address = ref1[0], setAddress = ref1[1];
    var ref2 = (0,react.useState)(false), isScrolled = ref2[0], setIsScrolled = ref2[1];
    var cords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var searchOptions = {
        componentRestrictions: {
            country: [
                "ca"
            ]
        }
    };
    var handleChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setAddress(value);
                return [
                    2
                ];
            });
        });
        return function handleChange(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var performGeocode = function(inputAddress1) {
        var googleMapsGeocoder = new google.maps.Geocoder();
        var inputAddress = inputAddress1;
        googleMapsGeocoder.geocode({
            address: inputAddress,
            componentRestrictions: {
                country: "ca"
            }
        }, function(results) {
            if (results && results.length > 0) {
                (0,dist/* getLatLng */.WV)(results[0]).then(function(latLng) {
                    if (inputAddress.includes("#")) {
                        inputAddress = inputAddress.replace("#", "");
                    }
                    var finalLatLng = latLng !== null && latLng !== void 0 ? latLng : utils_default/* default.0.center */.Z[0].center;
                    var cityName = (inputAddress === null || inputAddress === void 0 ? void 0 : inputAddress.toLowerCase().includes("halifax")) || (inputAddress === null || inputAddress === void 0 ? void 0 : inputAddress.toLowerCase().trim()) === "nova scotia" || (inputAddress === null || inputAddress === void 0 ? void 0 : inputAddress.toLowerCase().trim()) === "nova scotia, canada";
                    var coords = cityName ? constants/* HALIFAX_LAT_LANG */.JP : finalLatLng;
                    cords.setLatLangs(coords);
                    cords === null || cords === void 0 ? void 0 : cords.setSisterInput(false);
                    push("/self-storage/?location=".concat(inputAddress, "&lat=").concat(coords.lat, "&lng=").concat(coords.lng));
                });
            }
        });
    };
    var handleClick = function(searchItem) {
        var inputAddress = searchItem && searchItem.length ? searchItem : address;
        if ((inputAddress === null || inputAddress === void 0 ? void 0 : inputAddress.toLowerCase().trim()) === "nova scotia" || (inputAddress === null || inputAddress === void 0 ? void 0 : inputAddress.toLowerCase().trim()) === "nova scotia, canada") {
            push("/self-storage/?location=".concat(inputAddress, "&lat=").concat(constants/* HALIFAX_LAT_LANG.lat */.JP.lat, "&lng=").concat(constants/* HALIFAX_LAT_LANG.lng */.JP.lng));
        } else {
            performGeocode(inputAddress);
        }
    };
    var handleSelect = function(value) {
        setAddress(value);
        cords.setAddresses(value);
        handleClick(value);
    };
    // Log error status and clear dropdown when Google Maps API returns an error.
    var onError = function(status, clearSuggestions) {
        console.error("Google Maps API returned error with status: ", status);
        clearSuggestions();
    };
    var handleScrolled = (0,react.useCallback)(function(e) {
        e.preventDefault();
        var scrollValue = Math.floor(window.scrollY);
        if (scrollValue > 295) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    }, [
        isScrolled
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function(e) {
            return handleScrolled(e);
        });
        return function() {
            window.removeEventListener("scroll", function() {
                return handleScrolled;
            });
        };
    }, [
        isScrolled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((smart_textbox_style_module_default())["sv-smart-search-container"], " ").concat(isScrolled ? (smart_textbox_style_module_default()).scroll : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
            value: address,
            onChange: handleChange,
            onSelect: handleSelect,
            searchOptions: searchOptions,
            googleCallbackName: "initTwo",
            onError: onError,
            children: function(param) {
                var getInputProps = param.getInputProps, suggestions = param.suggestions, getSuggestionItemProps = param.getSuggestionItemProps, loading = param.loading;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (smart_textbox_style_module_default())["sv-smart-search"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                            className: (smart_textbox_style_module_default())["sv-search-input"]
                        }, getInputProps({
                            disabled: false,
                            placeholder: locale === "en" ? constants/* SEARCH_PLACEHOLDER_EN */.l3 : constants/* SEARCH_PLACEHOLDER_FR */.nr
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined/* default */.Z, {
                            className: (smart_textbox_style_module_default())["sv-search-icon"],
                            style: {
                                fontSize: "28px",
                                marginLeft: "unset",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return handleClick(address);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (smart_textbox_style_module_default())["sv-find-storage"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "header.find-storage"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (smart_textbox_style_module_default())["suggestions-dropdown"],
                            children: [
                                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "...loading"
                                }) : null,
                                suggestions.map(function(suggestion, index) {
                                    var style = {
                                        backgroundColor: suggestion.active ? "#e9ecef" : "#fff"
                                    };
                                    return /*#__PURE__*/ (0,react.createElement)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        className: (smart_textbox_style_module_default()).options
                                    }, getSuggestionItemProps(suggestion, {
                                        style: style
                                    })), {
                                        key: index
                                    }), suggestion.description);
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var smart_search_textbox = (SearchInput);

// EXTERNAL MODULE: ./src/components/header/right-panel-menu/right.module.scss
var right_module = __webpack_require__(53613);
var right_module_default = /*#__PURE__*/__webpack_require__.n(right_module);
;// CONCATENATED MODULE: ./src/components/header/right-panel-menu/index.tsx











var MyAccountModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88808));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88808)
            ];
        }
    }
});
var RightPanelMenu = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), showModal = ref4[0], setShowModal = ref4[1];
    var ref5 = (0,react.useState)(false), isCareersPage = ref5[0], setIsCareersPage = ref5[1];
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    // const { asPath } = useRouter();
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var easternTime = new Date().toLocaleString("en-US", {
        timeZone: "America/New_York"
    });
    var hour = new Date(easternTime).getHours();
    var contactNumber = (ref = headerFooter[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.RC_Contact_Number;
    var timings = (ref2 = headerFooter[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.Timings;
    var today = new Date().getDay();
    if (today === 0) today = 6;
    else today -= 1;
    var startTime = timings && timings[today].Start_Time;
    var endTime = timings && timings[today].End_Time;
    var openHours = "".concat(startTime, " ").concat(locale === "en" ? "to" : "\xe0", " ").concat(endTime, " ").concat(locale === "en" ? "ET" : ", HE");
    (0,react.useEffect)(function() {
        setIsCareersPage(router.asPath.includes("careers") || router.asPath.includes("carrieres"));
    }, [
        router
    ]);
    var isOpen = +hour >= 8 && +hour <= 21;
    var ContactInfo = function() {
        if (isOpen) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "header.weAreOpen"
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                startTime,
                " ",
                locale === "en" ? " to" : "\xe0",
                " ",
                endTime,
                " ",
                locale === "en" ? "ET" : ", HE"
            ]
        });
    };
    var contactStyle = function() {
        if (hour >= 8 && hour <= 21) {
            return (right_module_default()).call;
        }
        return "".concat((right_module_default()).call, " ").concat((right_module_default()).call_gray);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "right-menu",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "navbar-nav flex-row justify-content-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (right_module_default()).li,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_search_textbox, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((right_module_default()).li, " ").concat((right_module_default())["my-account-btn"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_button, {
                            onClick: function() {
                                return setShowModal(true);
                            },
                            text: "header.myaccount-makepayment",
                            textClassName: (right_module_default())["my-account"],
                            iconProps: {
                                style: {
                                    fontSize: "28px",
                                    maxWidth: "28px",
                                    maxHeight: "28px"
                                }
                            },
                            hasIcon: true,
                            Icon: AccountCircleOutlined/* default */.Z
                        })
                    }),
                    showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAccountModal, {
                        open: showModal,
                        onClose: function() {
                            return setShowModal(false);
                        }
                    }),
                    isCareersPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((right_module_default()).li, " nav-item"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex align-items-center h-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://careers.storagevaultcanada.com/",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn as-primary-btn",
                                    style: {
                                        fontSize: "16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "careers-header-apply"
                                    })
                                })
                            })
                        })
                    }),
                    !isCareersPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "".concat((right_module_default()).li, " nav-item"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (right_module_default())["sv-header-phone"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: contactStyle(),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalPhoneOutlined/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInfo, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "".concat((right_module_default())["sv-contact-number"], " nav-link pt-0 ps-0 text-center headerPhone"),
                                            href: "tel:".concat(contactNumber),
                                            "data-toggle": "tooltip",
                                            "data-placement": "top",
                                            title: openHours,
                                            children: contactNumber
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (right_module_default())["sv-header-phone-btn"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_button, {
                                    href: "tel:".concat(contactNumber),
                                    hasIcon: true,
                                    Icon: LocalPhoneOutlined/* default */.Z,
                                    text: "",
                                    dot: isOpen
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var right_panel_menu = (RightPanelMenu);

;// CONCATENATED MODULE: ./src/components/header/index.tsx
// import dynamic from 'next/dynamic';









// import imgLink from '@/public/images/logos/Access-25th-Logo.svg';





var Header = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var locale = (0,next_router.useRouter)().locale;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var ref15 = (0,react.useState)(false), isScrolled = ref15[0], setIsScrolled = ref15[1];
    var isContext = !!headerFooter[0];
    var ref16 = (0,react.useState)([]), brands = ref16[0], setBrands = ref16[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,home_setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        setBrands(contextData === null || contextData === void 0 ? void 0 : contextData.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    var ref17 = (0,react.useState)(false), expa = ref17[0], setExpa = ref17[1];
    var ref18 = (0,react.useState)({
        display: "none"
    }), showClass = ref18[0], setShowClass = ref18[1];
    var ref19 = (0,react.useState)(false), height = ref19[0], setHeight = ref19[1];
    var ref20 = (0,react.useState)({
        height: "0"
    }), heightStyle = ref20[0], setHeightStyle = ref20[1];
    var handleExpand = function() {
        setExpa(!expa);
        if (expa) {
            setShowClass({
                display: "none"
            });
            document.getElementById("nav-icon3").classList.remove("open");
        } else {
            setShowClass({
                display: "block"
            });
            setTimeout(function() {
                document.getElementById("storageDropdown").click();
            }, 100);
            document.getElementById("nav-icon3").classList.add("open");
        }
        setHeight(!height);
        if (height) setHeightStyle({
            height: "0"
        });
        else setHeightStyle({
            height: "600px"
        });
    };
    var handleCLose = function() {
        setExpa(false);
        setShowClass({
            display: "none"
        });
        setHeight(false);
        setHeightStyle({
            height: "0"
        });
        document.getElementById("nav-icon3").classList.remove("open");
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            setIsScrolled(window.scrollY > 0);
        };
        // Attach the event listener
        window.addEventListener("scroll", handleScroll);
        // Clean up the event listener on component unmount
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "".concat((Header_module_default())["sv-navbar"], " navbar sv-header ").concat(isScrolled ? "sv-header-shadow" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-xl custom-container px-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "nav-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "leftSide-nav",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_header, {
                                        showClass: showClass,
                                        heightStyle: heightStyle,
                                        handleExpand: handleExpand
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "navbar-brand",
                                            onClick: handleCLose,
                                            children: (brands === null || brands === void 0 ? void 0 : brands.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: (ref = brands[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Logo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attributes) === null || ref4 === void 0 ? void 0 : ref4.url,
                                                alt: "logo",
                                                width: "130",
                                                height: "60",
                                                priority: true
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: Access_Storage_Logo_RGB,
                                                alt: "logo",
                                                width: "130",
                                                height: "60",
                                                priority: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "navbar-brand",
                                        onClick: handleCLose,
                                        children: ((ref5 = brands[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.secondary_logo) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.attributes) === null || ref9 === void 0 ? void 0 : ref9.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref10 = brands[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.secondary_logo) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.attributes) === null || ref14 === void 0 ? void 0 : ref14.url,
                                            alt: "secondary-logo",
                                            width: "130",
                                            height: "60",
                                            priority: true
                                        }) : null
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rightSide-nav",
                                onClick: handleCLose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(right_panel_menu, {})
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./src/components/laylout/index.tsx









var Layout = function(param) {
    var children = param.children;
    var ref = (0,next_router.useRouter)(), locale = ref.locale, pathname = ref.pathname;
    var ref1 = (0,react.useState)(true), isMounted = ref1[0], setMount = ref1[1];
    var ref2 = (0,react.useContext)(HeaderFooterContext/* default */.ZP), isShowHeaderFooter = ref2.isShowHeaderFooter, isShowSelfHeader = ref2.isShowSelfHeader;
    var router = (0,next_router.useRouter)();
    var urlPath = router === null || router === void 0 ? void 0 : router.asPath.split("/");
    /* eslint-disable no-param-reassign */ var generateFrPath = function() {
        var frPath = "";
        urlPath.forEach(function(el) {
            if (el && el !== "en") {
                frPath += "/";
                el = Frkeys/* default */.Z[el] === undefined ? el : Frkeys/* default */.Z[el];
                frPath += el;
            }
        });
        return frPath;
    };
    var generateEnPath = function() {
        var enPath = "";
        urlPath.forEach(function(el) {
            if (el && el !== "fr") {
                enPath += "/";
                el = enkeys/* default */.Z[el] === undefined ? el : enkeys/* default */.Z[el];
                enPath += el;
            }
        });
        return enPath;
    };
    (0,react.useEffect)(function() {
        setMount(true);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        href: "".concat("https://dev-accessstorage.devv.ca", "/en").concat(generateEnPath(), "/"),
                        hrefLang: "en"
                    }, "en"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        href: "".concat("https://dev-accessstorage.devv.ca", "/fr").concat(generateFrPath(), "/"),
                        hrefLang: "fr"
                    }, "fr")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: pathname === "/" || pathname === "/self-storage/residential" || pathname === "/self-storage/moving" || pathname === "/self-storage/business" || pathname === "/self-storage/car-storage" || pathname === "/self-storage/home-staging" || pathname === "/self-storage/student-storage" || pathname === "/self-storage/climate-controlled-storage" || pathname === "/self-storage/boat-storage" || pathname === "/self-storage/motorcycle-storage" || pathname === "/self-storage/recretional-storage" || pathname === "/self-storage/rv-storage" || pathname === "/self-storage/truck-storage" ? "layout sv-wrapper ".concat(locale === "fr" ? "french-language" : "") : "layout sv-wrapper sticky_navigation ".concat(locale === "fr" ? "french-language" : ""),
                children: [
                    isShowSelfHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
                    isMounted ? children : null
                ]
            }),
            isShowHeaderFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};
/* harmony default export */ var laylout = (Layout);


/***/ }),

/***/ 66156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ getConvenientLocations; },
/* harmony export */   "YW": function() { return /* binding */ getHeaderAndFooterDetailsWithDefaultLocale; },
/* harmony export */   "Zy": function() { return /* binding */ getRightUnitInfo; },
/* harmony export */   "co": function() { return /* binding */ getVehicleLandingData; },
/* harmony export */   "fC": function() { return /* binding */ getCityLandingInfo; },
/* harmony export */   "fU": function() { return /* binding */ getInnerPagesWithDefaultLocale; },
/* harmony export */   "k5": function() { return /* binding */ getBrandReviews; },
/* harmony export */   "ns": function() { return /* binding */ getGoogleReviews; },
/* harmony export */   "zc": function() { return /* binding */ getOurBrands; }
/* harmony export */ });
/* unused harmony exports getGoogleReview, getHomeBodyDetailsWithDefaultLocale, getStudentSpecialContent, getValidityCity */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getHeaderAndFooterDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getBrandLocaleUrl */ .oo(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHeaderAndFooterDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getHomeBodyDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getHomeLocaleUrl */ .dK(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHomeBodyDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getBrandReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GOOGLE_CLIENT_REVIEWS */ .Zk), "get")
            ];
        });
    });
    return function getBrandReviews() {
        return _ref.apply(this, arguments);
    };
}();
var getOurBrands = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GET_OUR_BRANDS */ .e), "get")
            ];
        });
    });
    return function getOurBrands() {
        return _ref.apply(this, arguments);
    };
}();
// for future lcode include
var getGoogleReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReviews */ .Vf(lcode)), "get")
            ];
        });
    });
    return function getGoogleReviews(lcode) {
        return _ref.apply(this, arguments);
    };
}();
var getGoogleReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReview */ .tw(lcode, locale)), "get")
            ];
        });
    });
    return function getGoogleReview(lcode, locale) {
        return _ref.apply(this, arguments);
    };
}();
// lat, lng, brand, limit,
var getConvenientLocations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lang, cords) {
        var ncards;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            ncards = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .CONVENIENT_LOCATIONS */ .vi, "?lat=").concat(cords === null || cords === void 0 ? void 0 : cords.latitude, "&lng=").concat(cords === null || cords === void 0 ? void 0 : cords.longitude, "&brand=as&limit=").concat(ncards, "&lang=").concat(lang), "get")
            ];
        });
    });
    return function getConvenientLocations(lang, cords) {
        return _ref.apply(this, arguments);
    };
}();
// brand section
var getInnerPagesWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(innerPageName) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getInnerPagesUrl */ .zP(innerPageName, brand, locale)), "get")
            ];
        });
    });
    return function getInnerPagesWithDefaultLocale(innerPageName) {
        return _ref.apply(this, arguments);
    };
}();
// student special content
var getStudentSpecialContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(defaultLink, locale, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getStudentSpecialUrl */ .Sh(defaultLink, locale, brand)), "get")
            ];
        });
    });
    return function getStudentSpecialContent(defaultLink, locale, brand) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getCityLandingInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getCityLandingInfo */ .fC(slug, brand, locale)), "get")
            ];
        });
    });
    return function getCityLandingInfo(slug) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getVehicleLandingData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getVehicleLandingInfo */ .CZ(slug, brand, locale)), "get")
            ];
        });
    });
    return function getVehicleLandingData(slug) {
        return _ref.apply(this, arguments);
    };
}();
// right units
var getRightUnitInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getRightUnitInfo */ .Zy(brand, locale)), "get")
            ];
        });
    });
    return function getRightUnitInfo() {
        return _ref.apply(this, arguments);
    };
}();
// validate city for facility slug
var getValidityCity = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getValidateCity */ .e$(slug, brand)), "get")
            ];
        });
    });
    return function getValidityCity(slug, brand) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 76784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);



var SetBrandsContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var brand, locale, ref, result, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "dp", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
                    return [
                        4,
                        Promise.all([
                            (0,___WEBPACK_IMPORTED_MODULE_0__/* .getHeaderAndFooterDetailsWithDefaultLocale */ .YW)(brand, locale)
                        ])
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (ref = result[0]) === null || ref === void 0 ? void 0 : ref.data
                    ];
                case 2:
                    data = _state.sent() || null;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function SetBrandsContext() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (SetBrandsContext);


/***/ }),

/***/ 42169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getAllProvincesData; }
/* harmony export */ });
/* unused harmony export getStoreData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getAllProvincesData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var locale, brand;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            locale = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "en", brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getAllProvinces */ .lv(locale, brand)), "get")
            ];
        });
    });
    return function getAllProvincesData() {
        return _ref.apply(this, arguments);
    };
}();
var getStoreData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(province) {
        var locale, brand;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en", brand = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "as";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getProviStore */ .qY(province, locale, brand)), "get")
            ];
        });
    });
    return function getStoreData(province) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 84260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var defaultCenters = [
    {
        brand: "as",
        center: {
            lat: 43.7615714,
            lng: -79.2921276
        }
    },
    {
        brand: "dp",
        center: {
            lat: 45.4965782,
            lng: -73.5591249
        }
    },
    {
        brand: "se",
        center: {
            lat: 51.0553635,
            lng: -114.0186927
        }
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (defaultCenters);


/***/ }),

/***/ 89449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sv-navbar":"Header_sv-navbar__bELo_"};

/***/ }),

/***/ 97734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pointer":"mobile_pointer__MC8Yv"};

/***/ }),

/***/ 53613:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arrange":"right_arrange__e058Y","li":"right_li__HlfTK","call":"right_call__MNjQs","call_gray":"right_call_gray__AS5_U","pointer":"right_pointer__OdNb5","my-account":"right_my-account__1rtxX","sv-header-phone-btn":"right_sv-header-phone-btn__8DdZL","sv-contact-number":"right_sv-contact-number__rLojQ","sv-language-btn":"right_sv-language-btn__9wikD","my-account-btn":"right_my-account-btn__bGUEJ","sv-header-phone":"right_sv-header-phone__VPtzq"};

/***/ }),

/***/ 45492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sv-smart-button":"style_sv-smart-button__0V4sA","filterDot":"style_filterDot__6yKgm","changeBackground":"style_changeBackground__pbkPR"};

/***/ }),

/***/ 27034:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"suggestions-dropdown":"style_suggestions-dropdown__3CaiN","options":"style_options__426Fx","sv-smart-search-container":"style_sv-smart-search-container__dEIBN","sv-smart-search":"style_sv-smart-search__7OD11","sv-search-input":"style_sv-search-input__SCS4P","sv-find-storage":"style_sv-find-storage__y48ut","sv-search-icon":"style_sv-search-icon__PiiR5","scroll":"style_scroll___yHSj"};

/***/ })

}]);